//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * A built-in GLSL floating-point constant for <code>Math.PI</code>.\n\
 *\n\
 * @alias czm_pi\n\
 * @glslConstant\n\
 *\n\
 * @see CesiumMath.PI\n\
 *\n\
 * @example\n\
 * // GLSL declaration\n\
 * const float czm_pi = ...;\n\
 *\n\
 * // Example\n\
 * float twoPi = 2.0 * czm_pi;\n\
 */\n\
const float czm_pi = 3.141592653589793;\n\
";